var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "rich-text-container" }, [
    _vm.mode == "edit"
      ? _c(
          "div",
          [
            _c("RichText", {
              staticClass: "custom-richtext",
              attrs: { options: _vm.optionsRichText, "data-bot": _vm.dataBot },
              model: {
                value: _vm.localValue,
                callback: function($$v) {
                  _vm.localValue = $$v
                },
                expression: "localValue"
              }
            })
          ],
          1
        )
      : _c("div", {
          staticClass: "rich-text-html",
          domProps: { innerHTML: _vm._s(_vm.localValue) }
        })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }